import React from 'react';
import { domain } from './Domain.jsx';
import useApiRequest from './useApiRequest.jsx';
import { useLoginContext } from './LoginContext.jsx';
import notify from './Nots.jsx';

const TestNotifications = () => {
    const { postRequest } = useApiRequest();
    const { userInfo } = useLoginContext();

    const createSampleNotifications = async () => {
        try {
            const response = await postRequest(`${domain}/notifications/create-sample`);
            if (response.status === 201) {
                notify(response.body.message, 'success');
            }
        } catch (error) {
            notify('Failed to create sample notifications', 'error');
        }
    };

    if (!userInfo?.accessToken) {
        return <div>Please log in to test notifications</div>;
    }

    return (
        <div className="p-4">
            <button
                onClick={createSampleNotifications}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
                Create Sample Notifications
            </button>
        </div>
    );
};

export default TestNotifications; 